<template>
  <b-form-group :label="label" :label-sr-only="noLabel">
    <template #label>
      <slot name="label"></slot>
    </template>
    <div>
      <div class="text-info loader" v-if="loading">
        <b-spinner class="align-middle spinner"></b-spinner>
      </div>
      <slot name="prepend"></slot>
      <b-form-radio-group
        v-model="content"
        :state="state"
        @change="handleInput"
        :options="options"
        :value-field="valueField"
        :text-field="textField"
        :size="size"
        :buttons="botoes"
        button-variant="info"
      />
      <slot name="append"></slot>
      <b-form-invalid-feedback :state="state">{{
        feedback
      }}</b-form-invalid-feedback>
    </div>
  </b-form-group>
</template>

<script>
export default {
  name: "InputRadio",

  props: {
    value: { type: [String, Number, Object, Array], default: null },
    label: { type: String },
    required: { type: Boolean },
    loading: { type: Boolean },
    requiredMessage: { type: String },
    options: { type: Array, required: true },
    valueField: { type: String, default: "value" },
    textField: { type: String, default: "text" },
    size: { type: String, default: "" },
    noLabel: { type: Boolean, default: false },
    botoes: { type: Boolean, default: false }
  },
  data() {
    return {
      content: this.value,
      validForm: false,
      validState: false,
      hasError: false,
      errorMessage: "",
    };
  },
  computed: {
    requiredValid() {
      return !(this.required && !this.value);
    },
    state() {
      if (!this.validState) return null;
      if (!this.validForm && !this.value) return false;

      if (!this.requiredValid) return false;
      if (this.hasError) return false;

      return true;
    },
    feedback() {
      if (!this.requiredValid)
        return (
          this.requiredMessage ||
          this.$t("CAMPOS_VALIDACAO.REQUERIDO").formatUnicorn({
            name: this.label,
          })
        );

      if (this.hasError) return this.errorMessage;
      return "";
    }
  },
  methods: {
    showError(message) {
      this.validForm = true;
      this.hasError = true;
      this.errorMessage = message;
    },
    handleInput() {
      this.$emit("input", this.content);
      this.hasError = false;
    },
    valid() {
      this.validForm = true;
      this.validState = this.state === null || this.state === true;
      return this.state;
    },
    clear() {
      this.content = "";
      this.validForm = false;
      this.$emit("input", this.content);
    },
  },
  watch: {
    value: {
      handler(value) {
        this.content = value;
      },
      deep: true,
      immediate: true,
    },
  },
};
</script>

<style>
.loader {
  position: absolute;
  padding: 9px;
  z-index: 1;
}

.spinner {
  width: 18px;
  height: 18px;
}

.btn-group-toggle label{
  color: #FFF !important;
}
</style>
